var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconopersona(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.29 32.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #246370;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_5",
    "data-name": "Capa 5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m21.04,17.93c2.64-1.75,4.39-4.75,4.39-8.15C25.43,4.39,21.04,0,15.65,0S5.87,4.39,5.87,9.78c0,3.4,1.75,6.4,4.39,8.15C4.28,20.13,0,25.87,0,32.6h2.61c0-7.19,5.85-13.04,13.04-13.04s13.04,5.85,13.04,13.04h2.61c0-6.73-4.28-12.46-10.25-14.67Zm-5.39-.98c-3.95,0-7.17-3.22-7.17-7.17s3.22-7.17,7.17-7.17,7.17,3.22,7.17,7.17-3.22,7.17-7.17,7.17Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconopersona);
export default __webpack_public_path__ + "static/media/ICONOPERSONA.c550cf813248b6294f6bcf46759ddaf5.svg";
export { ForwardRef as ReactComponent };